export const defaultTheme = {
  colors: {
    primary: '#004b54',
    line: '#ddd',
    yellow: {
      _400: '#ffe33d',
      _100: '#fef8d3',
    },
    red: {
      _500: '#c73030',
      _400: '#d25959',
    },
    grey: {
      _400: '#9d9d9d',
      _300: '#e6e6e6',
      _100: '#f8f8f8',
    },
    green: {
      _600: '#54a34d',
    },
    blue: {
      _400: '#004b54',
      _300: '#9dbfe5',
      _100: '#e9f1f1',
    },
  },
  breakpoints: {
    mobile: '320px',
    mobile_large: '365px',
    mobile_landscape: '767px',
    tablet: '768px',
    tablet_landscape: '1024px',
    desktop: '1280px',
    desktop_large: '1440px',
    hd: '1920px',
  },
  padding: '24px',
  spacing: 8,
  zIndex: {
    header: 10,
  },
};

export type DefaultTheme = typeof defaultTheme;

declare module '@emotion/react' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  export interface Theme extends DefaultTheme {}
}
